<template>
    <div>
        <span> <img
                    v-if="params.data.from_user.picture"
                    class="person-img rounded-full"
                    :src="params.data.from_user.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  /></span>
    </div>
</template>

<script>
export default {
}
</script>